///salesorder/list
export const SALES_ORDER_LIST = "SALES_ORDER_LIST";
export const SALES_ORDER_LIST_SUCCESS = "SALES_ORDER_LIST_SUCCESS";
export const SALES_ORDER_LIST_FAILURE = "SALES_ORDER_LIST_FAILURE";

///salesorder/data
export const SALES_ORDER_DATA = "SALES_ORDER_DATA";
export const SALES_ORDER_DATA_SUCCESS = "SALES_ORDER_DATA_SUCCESS";
export const SALES_ORDER_DATA_FAILURE = "SALES_ORDER_DATA_FAILURE";

///salesorder/search
export const SALES_ORDER_SEARCH = "SALES_ORDER_SEARCH";
export const SALES_ORDER_SEARCH_SUCCESS = "SALES_ORDER_SEARCH_SUCCESS";
export const SALES_ORDER_SEARCH_FAILURE = "SALES_ORDER_SEARCH_FAILURE";

///salesorder/create
export const SALES_ORDER_CREATE = "SALES_ORDER_CREATE";
export const SALES_ORDER_CREATE_SUCCESS = "SALES_ORDER_CREATE_SUCCESS";
export const SALES_ORDER_CREATE_FAILURE = "SALES_ORDER_CREATE_FAILURE";

///salesorder/update
export const SALES_ORDER_UPDATE = "SALES_ORDER_UPDATE";
export const SALES_ORDER_UPDATE_SUCCESS = "SALES_ORDER_UPDATE_SUCCESS";
export const SALES_ORDER_UPDATE_FAILURE = "SALES_ORDER_UPDATE_FAILURE";

///salesorder/void
export const SALES_ORDER_VOID = "SALES_ORDER_VOID";
export const SALES_ORDER_VOID_SUCCESS = "SALES_ORDER_VOID_SUCCESS";
export const SALES_ORDER_VOID_FAILURE = "SALES_ORDER_VOID_FAILURE";

///salesorder/pdf
export const SALES_ORDER_PDF = "SALES_ORDER_PDF";
export const SALES_ORDER_PDF_SUCCESS = "SALES_ORDER_PDF_SUCCESS";
export const SALES_ORDER_PDF_FAILURE = "SALES_ORDER_PDF_FAILURE";

///salesorder/email/automated
export const SALES_ORDER_EMAIL_AUTOMATED = "SALES_ORDER_EMAIL_AUTOMATED";
export const SALES_ORDER_EMAIL_AUTOMATED_SUCCESS =
  "SALES_ORDER_EMAIL_AUTOMATED_SUCCESS";
export const SALES_ORDER_EMAIL_AUTOMATED_FAILURE =
  "SALES_ORDER_EMAIL_AUTOMATED_FAILURE";

///salesorder/emailresend/automated
export const SALES_ORDER_EMAIL_RESEND_AUTOMATED =
  "SALES_ORDER_EMAIL_RESEND_AUTOMATED";
export const SALES_ORDER_EMAIL_RESEND_AUTOMATED_SUCCESS =
  "SALES_ORDER_EMAIL_RESEND_AUTOMATED_SUCCESS";
export const SALES_ORDER_EMAIL_RESEND_AUTOMATED_FAILURE =
  "SALES_ORDER_EMAIL_RESEND_AUTOMATED_FAILURE";

///salesorderdailybalance
export const SALES_ORDER_DAILY_BALANCE = "SALES_ORDER_DAILY_BALANCE";
export const SALES_ORDER_DAILY_BALANCE_SUCCESS =
  "SALES_ORDER_DAILY_BALANCE_SUCCESS";
export const SALES_ORDER_DAILY_BALANCE_FAILURE =
  "SALES_ORDER_DAILY_BALANCE_FAILURE";

///salesorderitem/search
export const SALES_ORDER_ITEM_SEARCH = "SALES_ORDER_ITEM_SEARCH";
export const SALES_ORDER_ITEM_SEARCH_SUCCESS =
  "SALES_ORDER_ITEM_SEARCH_SUCCESS";
export const SALES_ORDER_ITEM_SEARCH_FAILURE =
  "SALES_ORDER_ITEM_SEARCH_FAILURE";

///salesorderitem/list
export const SALES_ORDER_ITEM_LIST = "SALES_ORDER_ITEM_LIST";
export const SALES_ORDER_ITEM_LIST_SUCCESS = "SALES_ORDER_ITEM_LIST_SUCCESS";
export const SALES_ORDER_ITEM_LIST_FAILURE = "SALES_ORDER_ITEM_LIST_FAILURE";

///salesorderstatus/list
export const SALES_ORDER_STATUS_LIST = "SALES_ORDER_STATUS_LIST";
export const SALES_ORDER_STATUS_LIST_SUCCESS =
  "SALES_ORDER_STATUS_LIST_SUCCESS";
export const SALES_ORDER_STATUS_LIST_FAILURE =
  "SALES_ORDER_STATUS_LIST_FAILURE";

///salesorderstatus/data
export const SALES_ORDER_STATUS_DATA = "SALES_ORDER_STATUS_DATA";
export const SALES_ORDER_STATUS_DATA_SUCCESS =
  "SALES_ORDER_STATUS_DATA_SUCCESS";
export const SALES_ORDER_STATUS_DATA_FAILURE =
  "SALES_ORDER_STATUS_DATA_FAILURE";

///salesorderstatus/create
export const SALES_ORDER_STATUS_CREATE = "SALES_ORDER_STATUS_CREATE";
export const SALES_ORDER_STATUS_CREATE_SUCCESS =
  "SALES_ORDER_STATUS_CREATE_SUCCESS";
export const SALES_ORDER_STATUS_CREATE_FAILURE =
  "SALES_ORDER_STATUS_CREATE_FAILURE";

///salesorderstatus/update
export const SALES_ORDER_STATUS_UPDATE = "SALES_ORDER_STATUS_UPDATE";
export const SALES_ORDER_STATUS_UPDATE_SUCCESS =
  "SALES_ORDER_STATUS_UPDATE_SUCCESS";
export const SALES_ORDER_STATUS_UPDATE_FAILURE =
  "SALES_ORDER_STATUS_UPDATE_FAILURE";

///salesorderstatus/delete
export const SALES_ORDER_STATUS_DELETE = "SALES_ORDER_STATUS_DELETE";
export const SALES_ORDER_STATUS_DELETE_SUCCESS =
  "SALES_ORDER_STATUS_DELETE_SUCCESS";
export const SALES_ORDER_STATUS_DELETE_FAILURE =
  "SALES_ORDER_STATUS_DELETE_FAILURE";

///salesorderactivitylog/search
export const SALES_ORDER_ACTIVITY_LOG_SEARCH =
  "SALES_ORDER_ACTIVITY_LOG_SEARCH";
export const SALES_ORDER_ACTIVITY_LOG_SEARCH_SUCCESS =
  "SALES_ORDER_ACTIVITY_LOG_SEARCH_SUCCESS";
export const SALES_ORDER_ACTIVITY_LOG_SEARCH_FAILURE =
  "SALES_ORDER_ACTIVITY_LOG_SEARCH_FAILURE";

///salesorder/converttoinvoice
export const SALES_ORDER_CONVERT_TO_INVOICE = "SALES_ORDER_CONVERT_TO_INVOICE";
export const SALES_ORDER_CONVERT_TO_INVOICE_SUCCESS =
  "SALES_ORDER_CONVERT_TO_INVOICE_SUCCESS";
export const SALES_ORDER_CONVERT_TO_INVOICE_FAILURE =
  "SALES_ORDER_CONVERT_TO_INVOICE_FAILURE";

///productstockreserved/search
export const PRODUCT_STOCK_RESERVED_SEARCH = "PRODUCT_STOCK_RESERVED_SEARCH";
export const PRODUCT_STOCK_RESERVED_SEARCH_SUCCESS =
  "PRODUCT_STOCK_RESERVED_SEARCH_SUCCESS";
export const PRODUCT_STOCK_RESERVED_SEARCH_FAILURE =
  "PRODUCT_STOCK_RESERVED_SEARCH_FAILURE";

///productstockreserved/list
export const PRODUCT_STOCK_RESERVED_LIST = "PRODUCT_STOCK_RESERVED_LIST";
export const PRODUCT_STOCK_RESERVED_LIST_SUCCESS =
  "PRODUCT_STOCK_RESERVED_LIST_SUCCESS";
export const PRODUCT_STOCK_RESERVED_LIST_FAILURE =
  "PRODUCT_STOCK_RESERVED_LIST_FAILURE";
